<!-- 文件已作废 -->
<!-- 目前最大分辨率支持16:9的尺寸【1512x854】【1440x814】【**1280x720】【**1164x687】【1000x564】（这是在宽度1512px的屏幕上测试；推测应该只支持设备屏幕clientWidth最大值）(*:最优大屏尺寸) -->

<!-- 优化动画效果（待完成） -->
<!-- 头像坐标点需要重做适配，paddingTop:2.083vw 去掉重新调（待完成） -->
<template>
  <div
    class="lineup_doubleTeam"
    :class="themeClass"
    :style="{ '--mixtmt_mixvw': mixvw }"
  >
    <div
      class="lineup_playgroundArea"
      ref="lineup_doubleTeamContainer"
      :style="{ perspective: dynamicWidthValPx }"
    >
      <span class="teamInfor_header show" v-if="lineupMap">
        <span
          class="teamItem"
          :class="teamItem.key"
          v-for="teamItem in lineupMap"
          :key="teamItem.key"
        >
          <span class="teamLogo">
            <img :src="teamItem.objectInfo.teamLogo" />
          </span>
          <span class="teamName" v-text="teamItem.objectInfo.teamName"></span>
          <span class="lineupNum" v-text="teamItem.lineupType"></span>
        </span>
      </span>
      <div class="playgroundArea_bg slide-rotate-hor-b-fwd">
        <span class="leftArea">
          <span class="playgroundBg_bigSquare"></span>
          <span class="playgroundBg_semiCircle"></span>
          <span class="playgroundBg_smallSquare"></span>
        </span>
        <span class="centerArea">
          <span class="centerArea_line"></span>
          <span class="centerArea_circle"></span>
          <span class="centerArea_line"></span>
        </span>
        <span class="rightArea">
          <span class="playgroundBg_bigSquare"></span>
          <span class="playgroundBg_semiCircle"></span>
          <span class="playgroundBg_smallSquare"></span>
        </span>
        <span class="playgroundBg_stripeBold">
          <i></i>
          <i></i>
          <i></i>
        </span>
        <span class="bottomArea"></span>
        <!-- <span
              class="leftTeam homeTeam"
              :class="
                lineupType ? `lineupType${lineupType}` : 'lineupType3-3-3-1'
              "
            >
              <span class="player" v-for="i in 11" :key="i">
                <span class="playerNo">
                  <i v-text="i"></i>
                </span>
                <span class="playerName">Vlachodimos (GK)</span>
              </span>
              <span class="lineup_type" v-text="lineupType"></span>
            </span>
            <span
              class="rightTeam awayTeam"
              :class="lineupType ? `lineupType${lineupType}` : 'lineupType4-5-1'"
            >
              <span class="player" v-for="i in 11" :key="i">
                <span class="playerNo">
                  <i v-text="i"></i>
                </span>
                <span class="playerName">Vlachodimos (GK)</span>
              </span>
              <span class="lineup_type" v-text="lineupType"></span>
            </span> -->
      </div>
      <template v-if="lineupMap">
        <span
          v-for="team in lineupMap"
          :key="team.key"
          :class="[
            team.lineupType
              ? `lineupType${team.lineupType}`
              : 'lineupType4-5-1',
            team.key == 'home' ? 'leftTeam homeTeam' : 'rightTeam awayTeam',
            initMapFlag ? 'init' : 'start',
          ]"
        >
          <span
            class="playerItem"
            v-for="(item, index) in team.list"
            :key="index"
            @click="playerDetail(item, 'start')"
          >
            <span
              class="playerOther_container"
              :style="{
                width: `${3.47 * mixvw}vw`,
                height: `${3.47 * mixvw}vw`,
              }"
            >
              <span class="playerLogo">
                <img v-show="item.playerLogo" :src="item.playerLogo" />
                <span v-show="!item.playerLogo" class="defautlPlayerImg"></span>
              </span>
              <span
                class="playerScore"
                v-text="item.score"
                :style="{
                  marginLeft: `${-0.533 * mixvw}vw`,
                  paddingTop: `${0.11 * mixvw}vw`,
                  width: `${1.11 * mixvw}vw`,
                  height: `${1.11 * mixvw}vw`,
                  fontSize: `${0.833 * mixvw}vw`,
                  lineHeight: `${1.11 * mixvw}vw`,
                }"
                v-if="item.score"
              ></span>
              <span
                class="shirtNumber"
                v-text="item.shirtNumber"
                :style="{
                  marginLeft: `${-0.694 * mixvw}vw`,
                  paddingTop: `${0.138 * mixvw}vw`,
                  width: `${1.388 * mixvw}vw`,
                  height: `${1.388 * mixvw}vw`,
                  fontSize: `${0.974 * mixvw}vw`,
                  lineHeight: `${1.388 * mixvw}vw`,
                }"
              ></span>
              <span
                class="playerEvents"
                :style="{
                  width: `${4.33 * mixvw}vw`,
                  height: `${3.47 * mixvw}vw`,
                  marginRight: `${-3.5 * mixvw}vw`,
                }"
                v-if="item.eventCodeWebs && item.eventCodeWebs.length > 0"
              >
                <span
                  v-for="(events, eventsIndex) in item.eventCodeWebs"
                  :key="eventsIndex"
                  :class="eventsIndex == 0 ? 'eventTop' : 'eventBottom'"
                  :style="{
                    height: `${1.11 * mixvw}vw`,
                    paddingTop: `${eventsIndex == 0 ? 0 : 1.25 * mixvw}vw`,
                  }"
                >
                  <span
                    class="eventItem"
                    v-for="event in events"
                    :key="event"
                    :class="[
                      event === 3 ? 'offStage' : '',
                      event === 4 ? 'yellowCard' : '',
                      event === 5 ? 'redCard' : '',
                      event === 0 ? 'point' : '',
                      event === 1 ? 'goal' : '',
                      event === 2 ? 'ownGoal' : '',
                    ]"
                  ></span>
                  <!-- <span class="eventItem yellowCard"></span>
                    <span class="eventItem redCard"></span>
                    <span class="eventItem offStage"></span> -->
                </span>
                <!-- <span class="eventBottom">
                    <span class="eventItem goal"></span>
                    <span class="eventItem point"></span>
                    <span class="eventItem ownGoal"></span>
                  </span> -->
              </span>
            </span>
            <span
              class="playerName"
              :style="{
                width: `calc(100% - ${2.2 * mixvw}vw)`,
                fontSize: `${0.833 * mixvw}vw`,
                lineHeight: `${1.25 * mixvw}vw`,
                padding: `0 ${0.588 * mixvw}vw`,
                margin: `${0.138 * mixvw}vw ${1.1 * mixvw}vw 0`,
              }"
              v-text="item.playerName"
            ></span>
          </span>
        </span>
      </template>
    </div>
  </div>
</template>
<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import lineupTypeMap from './lineup_layout.json'
export default {
  name: 'lineup_doubleTeam',
  props: {
    datas: {
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
      // 测试数据，主要是事件id
      // default: () => ({
      //   objectInfo: [
      //     {
      //       teamName: '阿根廷',
      //       teamId: 1020,
      //       teamLogo: 'https://images.mixtmt.com/hyper/football/team/1020.png',
      //       teamScore: 0,
      //       playerInfos: [],
      //     },
      //     {
      //       teamName: '法国',
      //       teamId: 1008,
      //       teamLogo: 'https://images.mixtmt.com/hyper/football/team/1008.png',
      //       teamScore: 0,
      //       playerInfos: [],
      //     },
      //   ],
      //   templateId: 1035,
      //   statisticsModels: [
      //     {
      //       id: 3365,
      //       name: '球员照片',
      //       tableName: null,
      //       columnName: 'playerLogo',
      //       type: null,
      //       sort: 1,
      //       statisticalEn: 'playerLogo',
      //       suffix: '',
      //       isAuto: null,
      //     },
      //     {
      //       id: 3366,
      //       name: '球员号码',
      //       tableName: null,
      //       columnName: 'shirtNumber',
      //       type: null,
      //       sort: 2,
      //       statisticalEn: 'shirtNumber',
      //       suffix: '',
      //       isAuto: null,
      //     },
      //     {
      //       id: 3367,
      //       name: '球员名称',
      //       tableName: null,
      //       columnName: 'playerName',
      //       type: null,
      //       sort: 3,
      //       statisticalEn: 'playerName',
      //       suffix: '',
      //       isAuto: null,
      //     },
      //     {
      //       id: 3368,
      //       name: '球员位置x',
      //       tableName: null,
      //       columnName: 'x',
      //       type: null,
      //       sort: 4,
      //       statisticalEn: 'x',
      //       suffix: '',
      //       isAuto: null,
      //     },
      //     {
      //       id: 3369,
      //       name: '球员位置y',
      //       tableName: null,
      //       columnName: 'y',
      //       type: null,
      //       sort: 5,
      //       statisticalEn: 'y',
      //       suffix: '',
      //       isAuto: null,
      //     },
      //     {
      //       id: 3370,
      //       name: '队长',
      //       tableName: null,
      //       columnName: 'isCaptain',
      //       type: null,
      //       sort: 6,
      //       statisticalEn: 'isCaptain',
      //       suffix: '',
      //       isAuto: null,
      //     },
      //   ],
      //   analysisItemId: 'cc286151c190442890ced8e0329cb724',
      //   competitionId: 109,
      //   seasonId: 1039,
      //   graphicsId: 24,
      //   title: '主队阵型',
      //   data: {
      //     dataList: [
      //       [
      //         {
      //           shirtNumber: 23,
      //           playerName: '埃米利亚诺·马丁内斯',
      //           playerId: 100672,
      //           teamId: 1020,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100672.png',
      //           formationUsed: '343d',
      //           formationPlace: 1,
      //           formationShow: '4-4-2',
      //           x: '1900',
      //           y: '120',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '埃米利亚诺·马丁内斯',
      //           score: '9.0',
      //           // events: [0, 1, 2, 3, 4, 5],
      //         },
      //         {
      //           shirtNumber: 3,
      //           playerName: '尼古拉斯·塔利亚菲科',
      //           playerId: 100673,
      //           teamId: 1020,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100673.png',
      //           formationUsed: '343d',
      //           formationPlace: 3,
      //           formationShow: '4-3-3',
      //           x: '800',
      //           y: '700',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '尼古拉斯·塔利亚菲科',
      //           events: [0, 1, 2, 3, 4, 5],
      //           score: '8.7',
      //         },
      //         {
      //           shirtNumber: 19,
      //           playerName: '尼古拉斯·奥塔门迪',
      //           playerId: 100720,
      //           teamId: 1020,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100720.png',
      //           formationUsed: '433',
      //           formationPlace: 6,
      //           formationShow: '4-3-3',
      //           x: '1500',
      //           y: '600',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '尼古拉斯·奥塔门迪',
      //           events: [0, 1, 2, 3, 4, 5],
      //           score: '6.8',
      //         },
      //         {
      //           shirtNumber: 13,
      //           playerName: '克里斯蒂安·罗梅罗',
      //           playerId: 102489,
      //           teamId: 1020,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102489.png',
      //           formationUsed: '433',
      //           formationPlace: 5,
      //           formationShow: '4-3-3',
      //           x: '2300',
      //           y: '600',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '克里斯蒂安·罗梅罗',
      //           score: '9.1',
      //         },
      //         {
      //           shirtNumber: 26,
      //           playerName: '纳韦尔·莫利纳',
      //           playerId: 102638,
      //           teamId: 1020,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102638.png',
      //           formationUsed: '433',
      //           formationPlace: 2,
      //           formationShow: '4-3-3',
      //           x: '3000',
      //           y: '700',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '纳韦尔·莫利纳',
      //           score: '7.7',
      //         },
      //         {
      //           shirtNumber: 20,
      //           playerName: '亚历克西斯·麦卡利斯特',
      //           playerId: 102102,
      //           teamId: 1020,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102102.png',
      //           formationUsed: '433',
      //           formationPlace: 8,
      //           formationShow: '4-3-3',
      //           x: '1200',
      //           y: '1000',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '亚历克西斯·麦卡利斯特',
      //           events: [0, 1, 2, 3, 4, 5],
      //           score: '9.9',
      //         },
      //         {
      //           shirtNumber: 24,
      //           playerName: '恩索·费尔南德斯',
      //           playerId: 102629,
      //           teamId: 1020,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102629.png',
      //           formationUsed: '433',
      //           formationPlace: 4,
      //           formationShow: '4-3-3',
      //           x: '1900',
      //           y: '830',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '恩索·费尔南德斯',
      //           score: '8.8',
      //         },
      //         {
      //           shirtNumber: 7,
      //           playerName: '罗德里戈·德保罗',
      //           playerId: 102630,
      //           teamId: 1020,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102630.png',
      //           formationUsed: '433',
      //           formationPlace: 7,
      //           formationShow: '4-3-3',
      //           x: '2600',
      //           y: '1000',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '罗德里戈·德保罗',
      //           score: '5.3',
      //         },
      //         {
      //           shirtNumber: 11,
      //           playerName: '安赫尔·迪马里亚',
      //           playerId: 100689,
      //           teamId: 1020,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100689.png',
      //           formationUsed: '433',
      //           formationPlace: 11,
      //           formationShow: '4-3-3',
      //           x: '1400',
      //           y: '1320',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '安赫尔·迪马里亚',
      //         },
      //         {
      //           shirtNumber: 9,
      //           playerName: '胡利安·阿尔瓦雷斯',
      //           playerId: 102356,
      //           teamId: 1020,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102356.png',
      //           formationUsed: '433',
      //           formationPlace: 9,
      //           formationShow: '4-3-3',
      //           x: '2400',
      //           y: '1320',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '胡利安·阿尔瓦雷斯',
      //         },
      //         {
      //           shirtNumber: 10,
      //           playerName: '利昂内尔·梅西',
      //           playerId: 100704,
      //           teamId: 1020,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100704.png',
      //           formationUsed: '433',
      //           formationPlace: 10,
      //           formationShow: '4-3-3',
      //           x: '1900',
      //           y: '1400',
      //           isCaptain: 1,
      //           teamLogo: '',
      //           playerNameWeb: '利昂内尔·梅西',
      //         },
      //       ],
      //       [
      //         {
      //           shirtNumber: 1,
      //           playerName: '雨果·洛里',
      //           playerId: 100108,
      //           teamId: 1008,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100108.png',
      //           formationUsed: '343d',
      //           formationPlace: 1,
      //           formationShow: '4-3-3',
      //           x: '1900',
      //           y: '120',
      //           isCaptain: 1,
      //           teamLogo: '',
      //           playerNameWeb: '雨果·洛里',
      //         },
      //         {
      //           shirtNumber: 22,
      //           playerName: '特奥·埃尔南德斯',
      //           playerId: 116257,
      //           teamId: 1008,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/116257.png',
      //           formationUsed: '433',
      //           formationPlace: 3,
      //           formationShow: '4-3-3',
      //           x: '800',
      //           y: '700',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '特奥·埃尔南德斯',
      //         },
      //         {
      //           shirtNumber: 18,
      //           playerName: '达约·乌帕梅卡诺',
      //           playerId: 102801,
      //           teamId: 1008,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102801.png',
      //           formationUsed: '433',
      //           formationPlace: 6,
      //           formationShow: '4-3-3',
      //           x: '1500',
      //           y: '600',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '达约·乌帕梅卡诺',
      //         },
      //         {
      //           shirtNumber: 4,
      //           playerName: '拉斐尔·瓦拉内',
      //           playerId: 100087,
      //           teamId: 1008,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100087.png',
      //           formationUsed: '433',
      //           formationPlace: 5,
      //           formationShow: '4-3-3',
      //           x: '2300',
      //           y: '600',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '拉斐尔·瓦拉内',
      //         },
      //         {
      //           shirtNumber: 5,
      //           playerName: '朱尔·昆代',
      //           playerId: 100101,
      //           teamId: 1008,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100101.png',
      //           formationUsed: '433',
      //           formationPlace: 2,
      //           formationShow: '4-3-3',
      //           x: '3000',
      //           y: '700',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '朱尔·昆代',
      //         },
      //         {
      //           shirtNumber: 14,
      //           playerName: '阿德里安·拉比奥',
      //           playerId: 100086,
      //           teamId: 1008,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100086.png',
      //           formationUsed: '433',
      //           formationPlace: 8,
      //           formationShow: '4-3-3',
      //           x: '1200',
      //           y: '1000',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '阿德里安·拉比奥',
      //         },
      //         {
      //           shirtNumber: 8,
      //           playerName: '奥雷利安·楚阿梅尼',
      //           playerId: 102794,
      //           teamId: 1008,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102794.png',
      //           formationUsed: '433',
      //           formationPlace: 4,
      //           formationShow: '4-3-3',
      //           x: '1900',
      //           y: '830',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '奥雷利安·楚阿梅尼',
      //         },
      //         {
      //           shirtNumber: 7,
      //           playerName: '安托万·格里茨曼',
      //           playerId: 100093,
      //           teamId: 1008,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100093.png',
      //           formationUsed: '433',
      //           formationPlace: 7,
      //           formationShow: '4-3-3',
      //           x: '2600',
      //           y: '1000',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '安托万·格里茨曼',
      //         },
      //         {
      //           shirtNumber: 10,
      //           playerName: '基利安·姆巴佩',
      //           playerId: 100091,
      //           teamId: 1008,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100091.png',
      //           formationUsed: '433',
      //           formationPlace: 11,
      //           formationShow: '4-3-3',
      //           x: '1400',
      //           y: '1320',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '基利安·姆巴佩',
      //         },
      //         {
      //           shirtNumber: 9,
      //           playerName: '奥利维耶·吉鲁',
      //           playerId: 100090,
      //           teamId: 1008,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100090.png',
      //           formationUsed: '433',
      //           formationPlace: 9,
      //           formationShow: '4-3-3',
      //           x: '2400',
      //           y: '1320',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '奥利维耶·吉鲁',
      //         },
      //         {
      //           shirtNumber: 11,
      //           playerName: '奥斯曼·登贝莱',
      //           playerId: 100100,
      //           teamId: 1008,
      //           playerLogo:
      //             'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100100.png',
      //           formationUsed: '433',
      //           formationPlace: 10,
      //           formationShow: '4-3-3',
      //           x: '1900',
      //           y: '1400',
      //           isCaptain: 0,
      //           teamLogo: '',
      //           playerNameWeb: '奥斯曼·登贝莱',
      //         },
      //       ],
      //     ],
      //   },
      //   limitCount: null,
      //   json: null,
      //   seasonOrMatch: true,
      //   haveCdvPackage: false,
      //   needPicture: false,
      //   needMax: false,
      // }),
    },
    themeClass: {
      type: String,
      default: '',
    },
    detailPathName: {
      type: String,
      default: '',
    },
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      originLineupMap: [],
      lineupMap: null,
      dataOrigin: 'opta',
      initMapFlag: true,
      dynamicWidthValPx: '500px',
      mixvw: 1,
    }
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.computedLineupMapHandler(newVal)
        }
      },
      immediate: true,
      // deep: true,
    },
  },
  created() {},
  mounted() {
    console.debug('dynamicWidthValPx:', this.$refs)
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.$nextTick(() => {
      this.onResizeEvent()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    onResizeEvent() {
      if (this.$refs.lineup_doubleTeamContainer) {
        this.dynamicWidthValPx =
          this.$refs.lineup_doubleTeamContainer.offsetWidth + 'px'
        this.mixvw = this.getMixvw(
          this.$refs.lineup_doubleTeamContainer.offsetWidth
        )
        console.debug('dom 存在', this.mixvw)
      } else {
        console.debug('dom 不存在')
      }
    },
    playerDetail(item) {
      // console.debug(item)
      if (this.detailPathName) {
        const query = this.$route.query
        let params = {
          cid: query && query.cid ? query.cid : '',
          sid: query && query.sid ? query.sid : '',
          tid: item.teamId,
          pid: item.playerId,
        }
        // console.debug(params)
        this.openNewWeb(this.$router, this.detailPathName, params)
      }
    },
    computedLineupMapHandler(datas) {
      let lineupMap = []
      if (datas && datas.objectInfo && datas.objectInfo.length === 2) {
        // 有数据才走逻辑，防止报错
        const typeKeys = ['home', 'away']

        let originLineupMap = typeKeys.map((key, keyIndex) => {
          return {
            key,
            objectInfo: datas.objectInfo[keyIndex],
            dataList:
              datas.data && datas.data.dataList && datas.data.dataList[keyIndex]
                ? datas.data.dataList[keyIndex]
                : [],
          }
        })

        // console.debug('computedLineupMapHandler:', datas, originLineupMap)
        originLineupMap.forEach((teamItem) => {
          const teamPlayers =
            teamItem && teamItem.dataList ? teamItem.dataList : []
          const lineupType =
            teamPlayers[0] && teamPlayers[0].formationUsed
              ? formatLineup(teamPlayers[0].formationUsed)
              : ''
          if (lineupType) {
            lineupMap.push({
              lineupType,
              objectInfo: teamItem.objectInfo,
              list: teamPlayers.map((player) => {
                let playerNameWeb = player.playerName
                if (player.position) {
                  playerNameWeb += `(${player.position})`
                }
                player.playerNameWeb = playerNameWeb
                if (player.events) {
                  const eventCodeTops = [],
                    eventCodeBottoms = [],
                    topCode = [3, 4, 5],
                    bottomCode = [0, 1, 2]
                  player.events.forEach((event) => {
                    const eventCode = this.eventCode2eventCodeWeb(event)
                    if (topCode.includes(eventCode)) {
                      eventCodeTops.push(eventCode)
                    }
                    if (bottomCode.includes(eventCode)) {
                      eventCodeBottoms.push(eventCode)
                    }
                  })
                  player.eventCodeWebs = [eventCodeTops, eventCodeBottoms]
                }

                if (typeof player.score === 'number') {
                  player.score = player.score + ''
                }

                return player
              }),
              key: teamItem.key,
            })
          }
        })
        const curLineupTypeMap = lineupTypeMap[this.dataOrigin]
        this.lineupMap = lineupMap.map((team) => {
          let lineupSort = curLineupTypeMap[team.lineupType]
          const newList = lineupSort.map((index) => {
            let item = null
            for (let i = 0; i < team.list.length; i++) {
              const player = team.list[i]
              if (player.formationPlace == index) {
                item = player
                break
              }
            }
            return item
          })
          return {
            lineupType: team.lineupType,
            list: newList,
            key: team.key,
            objectInfo: team.objectInfo,
          }
        })
        window.setTimeout(() => {
          this.initMapFlag = false
        }, 1.5 * 1000)
      }
      function formatLineup(formationUsed) {
        let lineupType = ''
        if (!formationUsed) {
          return lineupType
        }
        if (formationUsed.indexOf('d') > -1) {
          lineupType = '3-4-3d'
        } else {
          let arr = []
          for (let i = 0; i < formationUsed.length; i++) {
            arr.push(formationUsed[i])
          }
          lineupType = arr.join('-')
        }
        return lineupType
      }
    },
    eventCode2eventCodeWeb(num) {
      //后端code to 前端code
      let key = null
      switch (num) {
        case 1:
          key = 1
          break
        case 2:
          key = 0
          break
        case 3:
          key = 2
          break
        case 5:
          key = 4
          break
        case 6:
          key = 5
          break
        case 4:
          key = 6
          break
        case 9:
          key = 3
          break
        case 0:
          key = 7
          break
        default:
          key = null
          break
      }
      return key
    },
  },
}
</script>
<style lang="scss" scoped>
@-webkit-keyframes slide-rotate-hor-b-fwd {
  0% {
    -webkit-transform: translateY(0) translateZ(0) rotateX(0deg);
    transform: translateY(0) translateZ(0) rotateX(0deg);
    -webkit-transform-origin: top center;
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateY(3vw) translateZ(-10vw) rotateX(42deg);
    transform: translateY(3vw) translateZ(-10vw) rotateX(42deg);
    -webkit-transform-origin: top center;
    transform-origin: top center;
  }
}
@keyframes slide-rotate-hor-b-fwd {
  0% {
    -webkit-transform: translateY(0) translateZ(0) rotateX(0deg);
    transform: translateY(0) translateZ(0) rotateX(0deg);
    -webkit-transform-origin: top center;
    transform-origin: top center;
  }
  100% {
    -webkit-transform: translateY(3vw) translateZ(-10vw) rotateX(42deg);
    transform: translateY(3vw) translateZ(-10vw) rotateX(42deg);
    -webkit-transform-origin: top center;
    transform-origin: top center;
  }
}
.slide-rotate-hor-b-fwd {
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
  -webkit-animation: slide-rotate-hor-b-fwd 0.5s
    cubic-bezier(0.455, 0.03, 0.515, 0.955) both 1s;
  animation: slide-rotate-hor-b-fwd 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955)
    both 1s;
}

@-webkit-keyframes showHeader {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes showHeader {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes showBgBottomArea {
  0% {
    opacity: 0;
    top: 98%;
  }
  100% {
    opacity: 1;
    top: 100%;
  }
}
@-webkit-keyframes showBgBottomArea {
  0% {
    opacity: 0;
    top: 98%;
  }
  100% {
    opacity: 1;
    top: 100%;
  }
}

/* .lineup_doubleTeam {
    视频：16/9的比例
    padding: 7% 0;
} */
.lineup_doubleTeam {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  .lineup_playgroundArea {
    padding-top: 2.083vw;
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    .teamInfor_header {
      position: absolute;
      left: 2.776vw;
      top: 1.38vw;
      z-index: 10;
      width: calc(100% - 5.552vw);
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      transform: translateY(-50%);
      &.show {
        -webkit-animation: showHeader 0.5s
          cubic-bezier(0.455, 0.03, 0.515, 0.955) both 1.5s;
        animation: showHeader 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) both
          1.5s;
      }
      .teamItem {
        width: 50%;
        height: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        .teamLogo {
          width: 3.472vw;
          height: 3.472vw;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .teamName {
          /* padding-left: 1.042vw; */
          width: calc(100% - 3.472vw - 9.74vw - 2.778vw);
          font-size: 1.388vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .lineupNum {
          border-radius: 0.416vw;
          width: 9.74vw;
          font-size: 1.388vw;
          font-weight: bold;
          text-align: center;
          letter-spacing: 0.138vw;
        }
        &.home {
          .teamName {
            padding-left: 1.042vw;
            text-align: left;
          }
          .lineupNum {
            border: 1px solid var(--mixtmt_echarts_shootDis_ExpetGoal_homeColor);
            color: var(--mixtmt_echarts_shootDis_ExpetGoal_homeColor);
            /* background-color: var(--mixtmt_echarts_shootDis_ExpetGoal_homeColor); */
          }
        }
        &.away {
          flex-direction: row-reverse;

          .teamName {
            padding-right: 1.042vw;
            text-align: right;
          }
          .lineupNum {
            border: 1px solid var(--mixtmt_echarts_shootDis_ExpetGoal_awayColor);
            color: var(--mixtmt_echarts_shootDis_ExpetGoal_awayColor);
            /* background-color: var(--mixtmt_echarts_shootDis_ExpetGoal_awayColor); */
          }
        }
      }
    }
    .playgroundArea_bg {
      position: relative;
      width: 82%;
      padding-top: 40%;
      background-color: var(--mixtmt_lineup_playgroundArea_color1);
      /* border-radius: 1.388vw; */
      border-radius: 1.388vw 1.388vw 0.694vw 0.694vw;
      & .leftArea {
        .playgroundBg_bigSquare,
        .playgroundBg_smallSquare {
          left: 0;
          border-left: none;
        }
        .playgroundBg_semiCircle {
          left: 9%;
        }
      }
      & .rightArea {
        .playgroundBg_bigSquare,
        .playgroundBg_smallSquare {
          right: 0;
          border-right: none;
        }
        .playgroundBg_semiCircle {
          right: 9%;
        }
      }
      .playgroundBg_bigSquare {
        position: absolute;
        top: 17.5%;
        z-index: 20;
        width: 14%;
        height: 65%;
        background-color: var(--mixtmt_lineup_playgroundArea_color1);
        border: 1px solid var(--mixtmt_greyColor9);
      }
      .playgroundBg_semiCircle {
        position: absolute;
        top: 35%;
        z-index: 10;
        width: 8%;
        height: 30%;
        border: 1px solid var(--mixtmt_greyColor9);
        border-radius: 50%;
      }
      .playgroundBg_smallSquare {
        position: absolute;
        top: 32.75%;
        z-index: 30;
        width: 6%;
        height: 34.5%;
        border: 1px solid var(--mixtmt_greyColor9);
      }
      .playgroundBg_stripeBold {
        i {
          display: block;
          position: absolute;
          top: 0;
          z-index: 2;
          width: 14%;
          height: 100%;
          background-color: var(--mixtmt_lineup_playgroundArea_color2);
          &:first-child {
            left: 14%;
          }
          &:nth-child(2) {
            left: 42%;
            width: 16%;
          }
          &:last-child {
            right: 14%;
          }
        }
      }

      & .centerArea {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 50;
        width: 21%;
        height: 100%;
        transform: translate(-50%, -50%);
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        .centerArea_line {
          width: 1px;
          height: 100%;
          background-color: var(--mixtmt_greyColor9);
        }
        .centerArea_circle {
          position: relative;
          width: 100%;
          padding-top: 100%;
          border: 1px solid var(--mixtmt_greyColor9);
          border-radius: 50%;
          &::before {
            content: '\20';
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 55;
            transform: translate(-50%, -50%);
            width: 1%;
            height: 100%;
            background-color: var(--mixtmt_greyColor9);
          }
          &::after {
            content: '\20';
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 55;
            transform: translate(-50%, -50%);
            width: 6.66%;
            padding-top: 6.66%;
            background-color: var(--mixtmt_greyColor9);
            border-radius: 50%;
          }
        }
      }

      & .bottomArea {
        position: absolute;
        left: 1%;
        top: 100%;
        z-index: 10;
        width: 98%;
        height: 6.5%;
        background-color: var(--mixtmt_lineup_playgroundArea_color3);
        /* background-color: #3e3e3e; */
        transform: translateY(-0.138vw) translateZ(-1px) rotateX(-55deg);
        border-radius: 0 0 0.694vw 0.694vw;
        -webkit-animation: showBgBottomArea 0.6s
          cubic-bezier(0.455, 0.03, 0.515, 0.955) both 1s;
        animation: showBgBottomArea 0.6s cubic-bezier(0.455, 0.03, 0.515, 0.955)
          both 1s;
      }
      .theme_publishBtn {
        position: absolute;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 3.2vw;
        height: 3.2vw;
        opacity: 0.7;
        svg.publishBtn_icon {
          fill: var(--mixtmt_whiteColor);
        }
        &.home {
          top: 0;
          right: 0;
        }
        &.away {
          bottom: 0;
          left: 0;
        }
        &.allPlayerScore {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          top: -3.19vw;
          left: 0;
          width: 3.19vw;
          height: 3.19vw;
          svg.publishBtn_icon {
            fill: var(--mixtmt_blackColor);
          }
        }
      }
    }

    .lineup_type {
      position: absolute;
      z-index: 60;
      font-size: 1.388vw;
      color: var(--mixtmt_whiteColor);
    }

    .playerItem {
      position: absolute;
      z-index: 50;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      width: calc(4.858vw + 1.388vw + 1.388vw + 1vw);
      height: 4.858vw;
      color: var(--mixtmt_whiteColor);
      transition: all 0.5s ease-out;
      .playerOther_container {
        position: relative;
        width: 3.47vw;
        height: 3.47vw;
        .playerLogo {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .defautlPlayerImg {
            display: block;
            width: 100%;
            height: 100%;
            background-size: 100% 100%;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url('data:image/png;base64,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');
          }
        }
        .playerScore {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
          margin-left: -0.533vw;
          padding-top: 0.11vw;
          width: 1.11vw;
          height: 1.11vw;
          font-size: 0.833vw;
          line-height: 1.11vw;
          font-family: 'DINCondensed-Bold';
          text-align: center;
          background-color: var(--mixtmt_greyColor4);
          color: var(--mixtmt_whiteColor);
          border-radius: 0.138vw;
        }
        .shirtNumber {
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 2;
          margin-left: -0.694vw;
          padding-top: 0.138vw;
          width: 1.388vw;
          height: 1.388vw;
          font-size: 0.974vw;
          line-height: 1.388vw;
          font-family: 'DINCondensed-Bold';
          text-align: center;
          border-radius: 50%;
          // background-size: 100% 100%;
          // background-repeat: no-repeat;
          // background-position: center;
          // background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAADUklEQVRoBe1aTUwTQRSeN+0WBA1ejDFeRGNsrW2JJsabiTePGo2VH09qPEhARAU1Wo0RVEQIntST/Fij0aM3iTdjYgKtFYxRvBhjuEgUBJbu+GaxcbvZbZfObgGzvXTn/X7vvZk5vDdAHPoNh2u3EFnuVM1LUlMk0ffBCVdgt9FPO45XTP6euKQwUk8Yk1T7ADIF0lO+ouLqprf3Juz0aVsALBajyfjoUYUo1xDgGhOQ45TQi6Go/wHEYoqJzILItgSQ8B/erUC6izBSZck7kCHKPI3h0UevLMnnEBIKYKQqumF2ht1kjB3M4cOUBQBPfCVwNjAU/2IqlIdRUADD4bpyJsstwFgzI6w0j4+cbCAwzQA6QJLaI4neyZzCBswFBYCZhmQwWq0o7AbaWm9gT4T0lVI4F0rFB7AyzKohywGkgtU755R0Nwaxy6rxQuQQ/Gsv9TQEUwNvrOjnDeB9oHadTGbb8IAewbTklbfiNJ8MOmHo6aFEfK1bR/q+5ZI3BfRxb33J1Nj3JjR0njGyMpcRp3gA5BeGcr2scm3n5hc9M0Z+DANIBqL7FMY68IBuNFIqNg0P+mcK0BwaiT/X+84KIBGqCeHt0oVbZY9ecCmsEexLvK0aw8n+ZAYPzXzwfzY3d3+pglfxYWI5Ri3mrAC0jOXy7Qaw2JVyK+BWQDAD7hYSTKCwulsB4RQKGnArIJhAYXW3AsIpFDTgVkAwgcLqbgWEUyhowK2AYAKF1d0KCKdQ0MD/VQHweo9h+3NQMCkOqsPgPMZ/LrI6cxnykP/QfiC8tUgqM7TF/EeQY9jtba4affxMj8NwC3FBbKgGgNILaoNVr1WkNffNMXAsRuA5DMMKaPHNt9fldpw41mFF8sprdQv9RieYcOiViNRScHtd73zZDji0gfAR07tgdU1aSbcj3fYRk4d6WralBvodGTFpA+FDPiLPtmKhT9sx5MONeZtIvjbHh3zaIPi3OmadVm7h2Tig51lZ415/6iulZ4o+ZtWDUwfdROnGsxfR84zXMIwT+wY7Bt2G16ixU3MqBxKJBrbjmPQESo2bS5JxLsNl7QDP/dh+LfLHHj+nflxG0ye1jz2wOndXla2+smQfe+iz/ve5zR2VLkmnnHpu8wdttAstUoTIfwAAAABJRU5ErkJggg==");
        }
        .playerEvents {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 2;
          width: 4.33vw;
          height: 3.47vw;
          margin-right: -3.5vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          .eventTop,
          .eventBottom {
            width: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: flex-start;
            height: 1.11vw;
            .eventItem {
              display: flex;
              display: -webkit-flex;
              justify-content: center;
              align-items: center;
              background-color: var(--mixtmt_greyColor4);
              width: 1.11vw;
              height: 1.11vw;
              border-radius: 50%;
              margin-left: 0.138vw;
              &:first-child {
                margin-left: 0;
              }
              &::before {
                content: '\20';
                width: 0.833vw;
                height: 0.833vw;
                background-size: 100% 100%;
                background-position: center;
                background-repeat: no-repeat;
              }
              &.point::before {
                background-image: url('data:image/png;base64,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');
              }
              &.goal::before {
                background-image: url('data:image/png;base64,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');
              }
              &.ownGoal::before {
                background-image: url('data:image/png;base64,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');
              }

              &.offStage::before {
                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACiElEQVRoBe1ZPYgTQRSeNzF6HMbdRbCMv2BhYWEvKAcWJ4KVFt6PhcoJh4UcIqIcIiIixyF3HOLPmd1gqZ2FIKJY2FjaXXQ3CoIIJka84zB5zisW9tTdnezbYIqZZmbevPe+731vshsSIcwwCrAUAFZ0JPhb+QRGtqlLp17NBVumIvW5gyngfzfIdMB0gKmAuUJMAdnhpgNsCZkJTAeYArLDTQfYEjITmA4wBWSHmw6wJWQmMB1gCsgONx1gS8hMkPjTxvKO0fJKBw9qYXRwUcsvdJJwMlwmzRsK654P1hY/xvkkFoDT07L5oPYIBR6LS9BLOwDct3z3lJpjf3NKLIDI4b7TxcbX5ccC8XAvyf6ZW5G+q8ifSSJPMakFkBNuGx9oYvspIh6gfa+HInXHCryJNPLEQ+spBP7DFWtj6QiAeNNz8iAXdMkTF60OhKQb5QkH4ccLdZ32hrZcZ4B523cndZQPcbsqgIJaO0e2tH/hK0SxO0ySywxyzgncyW5zaV2haNJSzfuyvjgwpFTyo3bWWsLtLOQJs+sCKGhw6d4nUZRD6gJ+pj1nSAGzju+dy5qj6ysUBWrtGtvTXu28VO+JzVG77lqCmLGC6nld/3/5ZepAmKi0VHmnmnhIdeJ7aNOdAeQtLnnCYhVACex65W2hIIfVA+0n7XUGSLhpB+6Ujm+aD7sAAtj03n0NBXlUvSdW0wBBwA3b9y6k+eme51IAgdkfKs9QyOPqQ9WOA1cFXrfr3sW48yz23AogcPUofAJCjqsi/v7yBXDNDqqXspBMism1AAKy6m5VSDi7BlTCVSfwLq+x9fumsXV0iv56bZZHrvQ711h+re1j+2MPzYFRwCiQiwK/AW6dkE1GMlycAAAAAElFTkSuQmCC');
              }
              &.yellowCard::before,
              &.redCard::before {
                display: none;
              }
              &.yellowCard::after,
              &.redCard::after {
                content: '\20';
                width: 0.48vw;
                height: 0.64vw;
              }
              &.yellowCard::after {
                background-color: var(--mixtmt_matchEvent_yellowCard_color);
              }
              &.redCard::after {
                background-color: var(--mixtmt_matchEvent_redCard_color);
              }
            }
          }
          .eventBottom {
            padding-top: 1.25vw;
          }
        }
      }
      .playerName {
        width: calc(100% - 2.2vw);
        font-size: 0.833vw;
        line-height: 1.25vw;
        font-weight: bold;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 0.588vw;
        margin: 0.138vw 1.1vw 0;
        color: var(--mixtmt_greyColor3);
        /* background-color: var(--mixtmt_greyColor4); */
      }
    }

    .leftTeam {
      .playerItem {
        .playerOther_container {
          .shirtNumber {
            background-color: var(
              --mixtmt_echarts_shootDis_ExpetGoal_homeColor
            );
          }
        }
      }
    }
    .rightTeam {
      .playerItem {
        .playerOther_container {
          .shirtNumber {
            background-color: var(
              --mixtmt_echarts_shootDis_ExpetGoal_awayColor
            );
          }
        }
      }
    }

    .leftTeam.init {
      .playerItem {
        left: 45%;
        top: 40%;
      }
    }
    .rightTeam.init {
      .playerItem {
        right: 45%;
        top: 40%;
      }
    }

    /* 上半场布局是自上到下，自左到右；下半场布局是自下到上，自左到右 */
    .leftTeam.start {
      .lineup_type {
        top: 0;
        left: 0;
        padding: 3% 0 0 3%;
      }
      &.lineupType4-4-2 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 7.4%;
            bottom: 11%;
          }
          &:nth-child(3) {
            left: 9.9%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 12.5%;
            top: 32%;
          }
          &:nth-child(5) {
            left: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            left: 23.5%;
            bottom: 11%;
          }
          &:nth-child(7) {
            left: 25%;
            bottom: 32%;
          }
          &:nth-child(8) {
            left: 26.5%;
            top: 32%;
          }
          &:nth-child(9) {
            left: 28.5%;
            top: 14%;
          }
          &:nth-child(10) {
            left: 38.5%;
            bottom: 30%;
          }
          &:nth-child(11) {
            left: 39%;
            top: 30%;
          }
        }
      }
      &.lineupType4-3-3 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 7.4%;
            bottom: 11%;
          }
          &:nth-child(3) {
            left: 9.9%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 12.5%;
            top: 32%;
          }
          &:nth-child(5) {
            left: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            left: 24%;
            bottom: 20%;
          }
          &:nth-child(7) {
            left: 26%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            left: 27.5%;
            top: 20%;
          }
          &:nth-child(9) {
            left: 38.5%;
            bottom: 20%;
          }
          &:nth-child(10) {
            left: 39%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 20%;
          }
        }
      }
      &.lineupType4-5-1 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 7.4%;
            bottom: 11%;
          }
          &:nth-child(3) {
            left: 9.9%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 12.5%;
            top: 32%;
          }
          &:nth-child(5) {
            left: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            left: 23.8%;
            bottom: 8%;
          }
          &:nth-child(7) {
            left: 25%;
            bottom: 24.5%;
          }
          &:nth-child(8) {
            left: 26%;
            top: 51.5%;
            transform: translateY(-50%);
          }
          &:nth-child(9) {
            left: 27.3%;
            top: 28%;
          }
          &:nth-child(10) {
            left: 28.5%;
            top: 12%;
          }
          &:nth-child(11) {
            left: 39%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType5-3-2 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 7%;
            bottom: 8%;
          }
          &:nth-child(3) {
            left: 9%;
            bottom: 24.5%;
          }
          &:nth-child(4) {
            left: 11%;
            top: 52%;
            transform: translateY(-50%);
          }
          &:nth-child(5) {
            left: 13%;
            top: 28%;
          }
          &:nth-child(6) {
            left: 15%;
            top: 12%;
          }
          &:nth-child(7) {
            left: 24%;
            bottom: 20%;
          }
          &:nth-child(8) {
            left: 26%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(9) {
            left: 28%;
            top: 18%;
          }
          &:nth-child(10) {
            left: 38.5%;
            bottom: 30%;
          }
          &:nth-child(11) {
            left: 39%;
            top: 30%;
          }
        }
      }
      &.lineupType5-4-1 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 7%;
            bottom: 8%;
          }
          &:nth-child(3) {
            left: 9%;
            bottom: 24.5%;
          }
          &:nth-child(4) {
            left: 11%;
            top: 52%;
            transform: translateY(-50%);
          }
          &:nth-child(5) {
            left: 13%;
            top: 28%;
          }
          &:nth-child(6) {
            left: 15%;
            top: 12%;
          }
          &:nth-child(7) {
            left: 24%;
            bottom: 11%;
          }
          &:nth-child(8) {
            left: 25.5%;
            bottom: 32%;
          }
          &:nth-child(9) {
            left: 27%;
            top: 32%;
          }
          &:nth-child(10) {
            left: 28.6%;
            top: 14%;
          }
          &:nth-child(11) {
            left: 39%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType3-5-2 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 10%;
            bottom: 20%;
          }
          &:nth-child(3) {
            left: 12.8%;
            top: 42%;
          }
          &:nth-child(4) {
            left: 15.8%;
            top: 20%;
          }
          &:nth-child(5) {
            left: 23.5%;
            bottom: 8%;
          }
          &:nth-child(6) {
            left: 24.8%;
            bottom: 24.5%;
          }
          &:nth-child(7) {
            left: 26%;
            top: 51.5%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            left: 27%;
            top: 28%;
          }
          &:nth-child(9) {
            left: 28.2%;
            top: 12%;
          }
          &:nth-child(10) {
            left: 38.5%;
            bottom: 30%;
          }
          &:nth-child(11) {
            left: 39%;
            top: 30%;
          }
        }
      }
      &.lineupType3-4-3 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 10%;
            bottom: 20%;
          }
          &:nth-child(3) {
            left: 12.8%;
            top: 42%;
          }
          &:nth-child(4) {
            left: 15.8%;
            top: 20%;
          }
          &:nth-child(5) {
            left: 23.3%;
            bottom: 12%;
          }
          &:nth-child(6) {
            left: 25%;
            bottom: 34%;
          }
          &:nth-child(7) {
            left: 26.3%;
            top: 31%;
          }
          &:nth-child(8) {
            left: 28%;
            top: 13%;
          }
          &:nth-child(9) {
            left: 38.5%;
            bottom: 20%;
          }
          &:nth-child(10) {
            left: 39%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 20%;
          }
        }
      }
      &.lineupType3-4-3d {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 8.5%;
            bottom: 22%;
          }
          &:nth-child(3) {
            left: 11.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            left: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            left: 20%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(6) {
            left: 23%;
            bottom: 16%;
          }
          &:nth-child(7) {
            left: 26.5%;
            top: 18%;
          }
          &:nth-child(8) {
            left: 30%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(9) {
            left: 38.2%;
            bottom: 20%;
          }
          &:nth-child(10) {
            left: 39%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 20%;
          }
        }
      }
      &.lineupType4-2-4-0 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }

          &:nth-child(2) {
            left: 7%;
            bottom: 11%;
          }
          &:nth-child(3) {
            left: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 12.5%;
            top: 32%;
          }
          &:nth-child(5) {
            left: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            left: 24.5%;
            bottom: 30%;
          }
          &:nth-child(7) {
            left: 26%;
            top: 30%;
          }
          &:nth-child(8) {
            left: 37.5%;
            bottom: 11%;
          }
          &:nth-child(9) {
            left: 38%;
            bottom: 32%;
          }
          &:nth-child(10) {
            left: 38.5%;
            top: 32%;
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 14%;
          }
        }
      }
      &.lineupType4-4-1-1 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 7.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            left: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 12.5%;
            top: 33%;
          }
          &:nth-child(5) {
            left: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            left: 19.5%;
            bottom: 11%;
          }
          &:nth-child(7) {
            left: 21%;
            bottom: 32%;
          }
          &:nth-child(8) {
            left: 22.5%;
            top: 33%;
          }
          &:nth-child(9) {
            left: 24.3%;
            top: 14%;
          }
          &:nth-child(10) {
            left: 30.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType4-1-4-1 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 7%;
            bottom: 11%;
          }
          &:nth-child(3) {
            left: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 12.5%;
            top: 31.5%;
          }
          &:nth-child(5) {
            left: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            left: 20.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(7) {
            left: 27%;
            bottom: 11%;
          }
          &:nth-child(8) {
            left: 28.5%;
            bottom: 32%;
          }
          &:nth-child(9) {
            left: 30%;
            top: 33%;
          }
          &:nth-child(10) {
            left: 31.5%;
            top: 14%;
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType4-2-3-1 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 6.8%;
            bottom: 11%;
          }
          &:nth-child(3) {
            left: 9.4%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 12%;
            top: 33%;
          }
          &:nth-child(5) {
            left: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            left: 19%;
            bottom: 32%;
          }
          &:nth-child(7) {
            left: 21.5%;
            top: 28%;
          }
          &:nth-child(8) {
            left: 28.5%;
            bottom: 24%;
          }
          &:nth-child(9) {
            left: 30%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            left: 31.5%;
            top: 22%;
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType4-3-2-1 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 7%;
            bottom: 11%;
          }
          &:nth-child(3) {
            left: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 12.5%;
            top: 33%;
          }
          &:nth-child(5) {
            left: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            left: 20%;
            bottom: 18%;
          }
          &:nth-child(7) {
            left: 22%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            left: 23.5%;
            top: 19%;
          }
          &:nth-child(9) {
            left: 30.5%;
            bottom: 32.5%;
          }
          &:nth-child(10) {
            left: 32%;
            top: 27.5%;
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType4-2-2-2 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 7.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            left: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 12.5%;
            top: 33%;
          }
          &:nth-child(5) {
            left: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            left: 18%;
            bottom: 26%;
          }
          &:nth-child(7) {
            left: 21.5%;
            top: 26%;
          }
          &:nth-child(8) {
            left: 28.5%;
            bottom: 28.5%;
          }
          &:nth-child(9) {
            left: 30.5%;
            top: 28.5%;
          }
          &:nth-child(10) {
            left: 38.5%;
            bottom: 30%;
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 32%;
          }
        }
      }
      &.lineupType3-5-1-1 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            left: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            left: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            left: 18.5%;
            bottom: 8%;
          }
          &:nth-child(6) {
            left: 20.2%;
            bottom: 24.5%;
          }
          &:nth-child(7) {
            left: 21.5%;
            top: 51.5%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            left: 22.5%;
            top: 28%;
          }
          &:nth-child(9) {
            left: 24%;
            top: 12%;
          }
          &:nth-child(10) {
            left: 30.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType3-4-2-1 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            left: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            left: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            left: 17.8%;
            bottom: 10%;
          }
          &:nth-child(6) {
            left: 19.5%;
            bottom: 31%;
          }
          &:nth-child(7) {
            left: 20.8%;
            top: 34%;
          }
          &:nth-child(8) {
            left: 23%;
            top: 14%;
          }
          &:nth-child(9) {
            left: 29.5%;
            bottom: 27%;
          }
          &:nth-child(10) {
            left: 31.5%;
            top: 28%;
          }
          &:nth-child(11) {
            left: 38.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType3-4-1-2 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            left: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            left: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            left: 17.8%;
            bottom: 10%;
          }
          &:nth-child(6) {
            left: 19.5%;
            bottom: 31%;
          }
          &:nth-child(7) {
            left: 20.8%;
            top: 34%;
          }
          &:nth-child(8) {
            left: 23%;
            top: 14%;
          }
          &:nth-child(9) {
            left: 30.2%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            left: 38%;
            bottom: 30%;
          }
          &:nth-child(11) {
            left: 38.5%;
            top: 28%;
          }
        }
      }
      &.lineupType3-1-4-2 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            left: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            left: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            left: 21%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(6) {
            left: 27%;
            bottom: 10%;
          }
          &:nth-child(7) {
            left: 28.5%;
            bottom: 31%;
          }
          &:nth-child(8) {
            left: 30%;
            top: 32%;
          }
          &:nth-child(9) {
            left: 31.3%;
            top: 14%;
          }
          &:nth-child(10) {
            left: 39%;
            bottom: 33%;
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 30%;
          }
        }
      }
      &.lineupType4-1-3-2 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 6.8%;
            bottom: 11%;
          }
          &:nth-child(3) {
            left: 9.4%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 12%;
            top: 33%;
          }
          &:nth-child(5) {
            left: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            left: 20.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(7) {
            left: 28%;
            bottom: 18%;
          }
          &:nth-child(8) {
            left: 29.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(9) {
            left: 31.5%;
            top: 17.5%;
          }
          &:nth-child(10) {
            left: 39.2%;
            bottom: 33%;
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 31%;
          }
        }
      }
      &.lineupType4-3-1-2 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 7%;
            bottom: 11%;
          }
          &:nth-child(3) {
            left: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 12.5%;
            top: 33%;
          }
          &:nth-child(5) {
            left: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            left: 19.5%;
            bottom: 20%;
          }
          &:nth-child(7) {
            left: 21.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            left: 23.5%;
            top: 19%;
          }
          &:nth-child(9) {
            left: 31%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            left: 39%;
            bottom: 32%;
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 27.5%;
          }
        }
      }
      &.lineupType3-2-4-1 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            left: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            left: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            left: 19%;
            bottom: 33%;
          }
          &:nth-child(6) {
            left: 21%;
            top: 28%;
          }
          &:nth-child(7) {
            left: 27.5%;
            bottom: 10%;
          }
          &:nth-child(8) {
            left: 29%;
            bottom: 30%;
          }
          &:nth-child(9) {
            left: 30.2%;
            top: 35%;
          }
          &:nth-child(10) {
            left: 31.5%;
            top: 16%;
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType3-3-3-1 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            left: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            left: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            left: 19%;
            bottom: 22%;
          }
          &:nth-child(6) {
            left: 20.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(7) {
            left: 23%;
            top: 20%;
          }
          &:nth-child(8) {
            left: 28.5%;
            bottom: 15%;
          }
          &:nth-child(9) {
            left: 30.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            left: 32.5%;
            top: 14%;
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType4-1-2-1-2 {
        .playerItem {
          &:first-child {
            left: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }

          &:nth-child(2) {
            left: 6%;
            bottom: 10%;
          }
          &:nth-child(3) {
            left: 9%;
            bottom: 32%;
          }
          &:nth-child(4) {
            left: 11.5%;
            top: 30%;
          }
          &:nth-child(5) {
            left: 14.5%;
            top: 12%;
          }
          &:nth-child(6) {
            left: 19%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(7) {
            left: 23%;
            bottom: 17%;
          }
          &:nth-child(8) {
            left: 26.3%;
            top: 17%;
          }
          &:nth-child(9) {
            left: 31%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            left: 39%;
            bottom: 27%;
          }
          &:nth-child(11) {
            left: 39.5%;
            top: 25%;
          }
        }
      }
      &.lineupType3-1-3-1-2 {
        .playerItem {
          &:first-child {
            left: 2.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            left: 7%;
            bottom: 24%;
          }
          &:nth-child(3) {
            left: 10%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            left: 13%;
            top: 20%;
          }
          &:nth-child(5) {
            left: 18%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(6) {
            left: 23.5%;
            bottom: 12%;
          }
          &:nth-child(7) {
            left: 26%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            left: 27.8%;
            top: 15%;
          }
          &:nth-child(9) {
            left: 35%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            left: 39.5%;
            bottom: 27%;
          }
          &:nth-child(11) {
            left: 40%;
            top: 25%;
          }
        }
      }
    }
    .rightTeam.start {
      .lineup_type {
        bottom: 0;
        right: 0;
        padding: 0 3% 3% 0;
      }
      &.lineupType4-4-2 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 8.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            right: 10.5%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 13%;
            top: 32%;
          }
          &:nth-child(5) {
            right: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            right: 23%;
            bottom: 11%;
          }
          &:nth-child(7) {
            right: 25%;
            bottom: 32%;
          }
          &:nth-child(8) {
            right: 26%;
            top: 32%;
          }
          &:nth-child(9) {
            right: 27.5%;
            top: 14%;
          }
          &:nth-child(10) {
            right: 38.5%;
            bottom: 30%;
          }
          &:nth-child(11) {
            right: 39%;
            top: 30%;
          }
        }
      }
      &.lineupType4-3-3 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 8.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            right: 10.5%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 13%;
            top: 32%;
          }
          &:nth-child(5) {
            right: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            right: 24%;
            bottom: 20%;
          }
          &:nth-child(7) {
            right: 26%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            right: 27.5%;
            top: 20%;
          }
          &:nth-child(9) {
            right: 38.5%;
            bottom: 20%;
          }
          &:nth-child(10) {
            right: 39%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 20%;
          }
        }
      }
      &.lineupType4-5-1 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 8.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            right: 10.5%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 13%;
            top: 32%;
          }
          &:nth-child(5) {
            right: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            right: 23.8%;
            bottom: 8%;
          }
          &:nth-child(7) {
            right: 25%;
            bottom: 24.5%;
          }
          &:nth-child(8) {
            right: 26%;
            top: 51.5%;
            transform: translateY(-50%);
          }
          &:nth-child(9) {
            right: 27.3%;
            top: 28%;
          }
          &:nth-child(10) {
            right: 28%;
            top: 12%;
          }
          &:nth-child(11) {
            right: 39%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType5-3-2 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 7%;
            bottom: 8%;
          }
          &:nth-child(3) {
            right: 9%;
            bottom: 24.5%;
          }
          &:nth-child(4) {
            right: 11%;
            top: 52%;
            transform: translateY(-50%);
          }
          &:nth-child(5) {
            right: 13%;
            top: 28%;
          }
          &:nth-child(6) {
            right: 14.8%;
            top: 12%;
          }
          &:nth-child(7) {
            right: 24%;
            bottom: 20%;
          }
          &:nth-child(8) {
            right: 26%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(9) {
            right: 27.5%;
            top: 18%;
          }
          &:nth-child(10) {
            right: 38.5%;
            bottom: 30%;
          }
          &:nth-child(11) {
            right: 39%;
            top: 30%;
          }
        }
      }
      &.lineupType5-4-1 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 7%;
            bottom: 8%;
          }
          &:nth-child(3) {
            right: 9%;
            bottom: 24.5%;
          }
          &:nth-child(4) {
            right: 11%;
            top: 52%;
            transform: translateY(-50%);
          }
          &:nth-child(5) {
            right: 13%;
            top: 28%;
          }
          &:nth-child(6) {
            right: 14.8%;
            top: 12%;
          }
          &:nth-child(7) {
            right: 24%;
            bottom: 11%;
          }
          &:nth-child(8) {
            right: 25.5%;
            bottom: 32%;
          }
          &:nth-child(9) {
            right: 26.5%;
            top: 32%;
          }
          &:nth-child(10) {
            right: 27.5%;
            top: 14%;
          }
          &:nth-child(11) {
            right: 39%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType3-5-2 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 9.5%;
            bottom: 20%;
          }
          &:nth-child(3) {
            right: 12.8%;
            top: 42%;
          }
          &:nth-child(4) {
            right: 15%;
            top: 20%;
          }
          &:nth-child(5) {
            right: 24%;
            bottom: 8%;
          }
          &:nth-child(6) {
            right: 24.8%;
            bottom: 24.5%;
          }
          &:nth-child(7) {
            right: 26.3%;
            top: 51.5%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            right: 27%;
            top: 28%;
          }
          &:nth-child(9) {
            right: 28%;
            top: 12%;
          }
          &:nth-child(10) {
            right: 38.5%;
            bottom: 30%;
          }
          &:nth-child(11) {
            right: 39%;
            top: 30%;
          }
        }
      }
      &.lineupType3-4-3 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 9.5%;
            bottom: 20%;
          }
          &:nth-child(3) {
            right: 12.8%;
            top: 42%;
          }
          &:nth-child(4) {
            right: 15%;
            top: 20%;
          }
          &:nth-child(5) {
            right: 23.3%;
            bottom: 12%;
          }
          &:nth-child(6) {
            right: 25%;
            bottom: 34%;
          }
          &:nth-child(7) {
            right: 26.3%;
            top: 31%;
          }
          &:nth-child(8) {
            right: 27.5%;
            top: 13%;
          }
          &:nth-child(9) {
            right: 38.5%;
            bottom: 20%;
          }
          &:nth-child(10) {
            right: 39%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 20%;
          }
        }
      }
      &.lineupType3-4-3d {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            right: 11.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            right: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            right: 20%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(6) {
            right: 23%;
            bottom: 16%;
          }
          &:nth-child(7) {
            right: 26.5%;
            top: 18%;
          }
          &:nth-child(8) {
            right: 30%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(9) {
            right: 38.2%;
            bottom: 20%;
          }
          &:nth-child(10) {
            right: 38.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(11) {
            right: 39%;
            top: 20%;
          }
        }
      }
      &.lineupType4-2-4-0 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }

          &:nth-child(2) {
            right: 7.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            right: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 12%;
            top: 32%;
          }
          &:nth-child(5) {
            right: 14.5%;
            top: 14%;
          }
          &:nth-child(6) {
            right: 24.5%;
            bottom: 30%;
          }
          &:nth-child(7) {
            right: 26%;
            top: 30%;
          }
          &:nth-child(8) {
            right: 36.5%;
            bottom: 11%;
          }
          &:nth-child(9) {
            right: 37.5%;
            bottom: 32%;
          }
          &:nth-child(10) {
            right: 38%;
            top: 32%;
          }
          &:nth-child(11) {
            right: 38.5%;
            top: 14%;
          }
        }
      }
      &.lineupType4-4-1-1 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 7.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            right: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 12%;
            top: 33%;
          }
          &:nth-child(5) {
            right: 14.2%;
            top: 14%;
          }
          &:nth-child(6) {
            right: 19.8%;
            bottom: 11%;
          }
          &:nth-child(7) {
            right: 21.3%;
            bottom: 32%;
          }
          &:nth-child(8) {
            right: 22.8%;
            top: 33%;
          }
          &:nth-child(9) {
            right: 24.3%;
            top: 14%;
          }
          &:nth-child(10) {
            right: 30.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType4-1-4-1 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 8%;
            bottom: 11%;
          }
          &:nth-child(3) {
            right: 10%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 12.5%;
            top: 31.5%;
          }
          &:nth-child(5) {
            right: 14.5%;
            top: 14%;
          }
          &:nth-child(6) {
            right: 20.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(7) {
            right: 27%;
            bottom: 11%;
          }
          &:nth-child(8) {
            right: 28.5%;
            bottom: 32%;
          }
          &:nth-child(9) {
            right: 30%;
            top: 33%;
          }
          &:nth-child(10) {
            right: 31%;
            top: 14%;
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType4-2-3-1 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 7.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            right: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 12%;
            top: 33%;
          }
          &:nth-child(5) {
            right: 14.5%;
            top: 14%;
          }
          &:nth-child(6) {
            right: 19%;
            bottom: 32%;
          }
          &:nth-child(7) {
            right: 21.5%;
            top: 28%;
          }
          &:nth-child(8) {
            right: 28.5%;
            bottom: 24%;
          }
          &:nth-child(9) {
            right: 30%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            right: 31%;
            top: 22%;
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType4-3-2-1 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 7.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            right: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 12%;
            top: 33%;
          }
          &:nth-child(5) {
            right: 14%;
            top: 14%;
          }
          &:nth-child(6) {
            right: 20%;
            bottom: 18%;
          }
          &:nth-child(7) {
            right: 22%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            right: 23.5%;
            top: 19%;
          }
          &:nth-child(9) {
            right: 30.5%;
            bottom: 32.5%;
          }
          &:nth-child(10) {
            right: 32%;
            top: 27.5%;
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType4-2-2-2 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 7.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            right: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 12.5%;
            top: 33%;
          }
          &:nth-child(5) {
            right: 15%;
            top: 14%;
          }
          &:nth-child(6) {
            right: 18%;
            bottom: 26%;
          }
          &:nth-child(7) {
            right: 21.5%;
            top: 26%;
          }
          &:nth-child(8) {
            right: 28.5%;
            bottom: 28.5%;
          }
          &:nth-child(9) {
            right: 30.5%;
            top: 28.5%;
          }
          &:nth-child(10) {
            right: 38.5%;
            bottom: 30%;
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 32%;
          }
        }
      }
      &.lineupType3-5-1-1 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            right: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            right: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            right: 18.5%;
            bottom: 8%;
          }
          &:nth-child(6) {
            right: 20.2%;
            bottom: 24.5%;
          }
          &:nth-child(7) {
            right: 21.5%;
            top: 51.5%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            right: 22.5%;
            top: 28%;
          }
          &:nth-child(9) {
            right: 24%;
            top: 12%;
          }
          &:nth-child(10) {
            right: 30.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType3-4-2-1 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            right: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            right: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            right: 17.8%;
            bottom: 10%;
          }
          &:nth-child(6) {
            right: 19.5%;
            bottom: 31%;
          }
          &:nth-child(7) {
            right: 21%;
            top: 34%;
          }
          &:nth-child(8) {
            right: 22.5%;
            top: 14%;
          }
          &:nth-child(9) {
            right: 30%;
            bottom: 27%;
          }
          &:nth-child(10) {
            right: 31.5%;
            top: 28%;
          }
          &:nth-child(11) {
            right: 38.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType3-4-1-2 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            right: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            right: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            right: 17.8%;
            bottom: 10%;
          }
          &:nth-child(6) {
            right: 19.5%;
            bottom: 31%;
          }
          &:nth-child(7) {
            right: 21.5%;
            top: 34%;
          }
          &:nth-child(8) {
            right: 23%;
            top: 14%;
          }
          &:nth-child(9) {
            right: 30.2%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            right: 38%;
            bottom: 30%;
          }
          &:nth-child(11) {
            right: 38.5%;
            top: 28%;
          }
        }
      }
      &.lineupType3-1-4-2 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            right: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            right: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            right: 21%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(6) {
            right: 27%;
            bottom: 10%;
          }
          &:nth-child(7) {
            right: 28.5%;
            bottom: 31%;
          }
          &:nth-child(8) {
            right: 30%;
            top: 32%;
          }
          &:nth-child(9) {
            right: 31.3%;
            top: 14%;
          }
          &:nth-child(10) {
            right: 39%;
            bottom: 33%;
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 30%;
          }
        }
      }
      &.lineupType4-1-3-2 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 7.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            right: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 12%;
            top: 33%;
          }
          &:nth-child(5) {
            right: 14.5%;
            top: 14%;
          }
          &:nth-child(6) {
            right: 20.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(7) {
            right: 28%;
            bottom: 18%;
          }
          &:nth-child(8) {
            right: 30%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(9) {
            right: 31.5%;
            top: 17.5%;
          }
          &:nth-child(10) {
            right: 39.2%;
            bottom: 33%;
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 31%;
          }
        }
      }
      &.lineupType4-3-1-2 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 7.5%;
            bottom: 11%;
          }
          &:nth-child(3) {
            right: 9.8%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 12%;
            top: 33%;
          }
          &:nth-child(5) {
            right: 14.5%;
            top: 14%;
          }
          &:nth-child(6) {
            right: 19.5%;
            bottom: 20%;
          }
          &:nth-child(7) {
            right: 21.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            right: 23.5%;
            top: 19%;
          }
          &:nth-child(9) {
            right: 31%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            right: 39%;
            bottom: 32%;
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 27.5%;
          }
        }
      }
      &.lineupType3-2-4-1 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            right: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            right: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            right: 19%;
            bottom: 33%;
          }
          &:nth-child(6) {
            right: 21%;
            top: 28%;
          }
          &:nth-child(7) {
            right: 27.5%;
            bottom: 10%;
          }
          &:nth-child(8) {
            right: 29%;
            bottom: 30%;
          }
          &:nth-child(9) {
            right: 30.2%;
            top: 35%;
          }
          &:nth-child(10) {
            right: 31.5%;
            top: 16%;
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType3-3-3-1 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 9%;
            bottom: 22%;
          }
          &:nth-child(3) {
            right: 11.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            right: 14%;
            top: 20%;
          }
          &:nth-child(5) {
            right: 19%;
            bottom: 22%;
          }
          &:nth-child(6) {
            right: 20.8%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(7) {
            right: 23%;
            top: 20%;
          }
          &:nth-child(8) {
            right: 28.5%;
            bottom: 15%;
          }
          &:nth-child(9) {
            right: 30.5%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            right: 32%;
            top: 14%;
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 48%;
            transform: translateY(-50%);
          }
        }
      }
      &.lineupType4-1-2-1-2 {
        .playerItem {
          &:first-child {
            right: 3.5%;
            top: 45%;
            transform: translateY(-50%);
          }

          &:nth-child(2) {
            right: 6.2%;
            bottom: 10%;
          }
          &:nth-child(3) {
            right: 9.2%;
            bottom: 32%;
          }
          &:nth-child(4) {
            right: 11.8%;
            top: 30%;
          }
          &:nth-child(5) {
            right: 14%;
            top: 12%;
          }
          &:nth-child(6) {
            right: 19%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(7) {
            right: 23%;
            bottom: 17%;
          }
          &:nth-child(8) {
            right: 26.3%;
            top: 17%;
          }
          &:nth-child(9) {
            right: 31%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            right: 39%;
            bottom: 27%;
          }
          &:nth-child(11) {
            right: 39.5%;
            top: 25%;
          }
        }
      }
      &.lineupType3-1-3-1-2 {
        .playerItem {
          &:first-child {
            right: 2.5%;
            top: 45%;
            transform: translateY(-50%);
          }
          &:nth-child(2) {
            right: 7%;
            bottom: 24%;
          }
          &:nth-child(3) {
            right: 10%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(4) {
            right: 12%;
            top: 20%;
          }
          &:nth-child(5) {
            right: 18%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(6) {
            right: 23.5%;
            bottom: 12%;
          }
          &:nth-child(7) {
            right: 26%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(8) {
            right: 27.8%;
            top: 15%;
          }
          &:nth-child(9) {
            right: 35%;
            top: 48%;
            transform: translateY(-50%);
          }
          &:nth-child(10) {
            right: 39.5%;
            bottom: 27%;
          }
          &:nth-child(11) {
            right: 40%;
            top: 25%;
          }
        }
      }
    }

    .homeTeam {
      .playerNo {
        background-image: var(--mixtmt_homePlayerNo_bg);
      }
    }
    .awayTeam {
      .playerNo {
        background-image: var(--mixtmt_awayPlayerNo_bg);
      }
    }
  }
}

.mixtmt_pc .lineup_doubleTeam {
  .homeTeam {
    .playerOther_container {
      &:hover {
        & ~ .playerName {
          background-color: var(--mixtmt_echarts_shootDis_ExpetGoal_homeColor);
        }
      }
    }
    .playerName {
      &:hover {
        background-color: var(--mixtmt_echarts_shootDis_ExpetGoal_homeColor);
      }
    }
  }
  .awayTeam {
    .playerOther_container {
      &:hover {
        & ~ .playerName {
          background-color: var(--mixtmt_echarts_shootDis_ExpetGoal_awayColor);
        }
      }
    }
    .playerName {
      &:hover {
        background-color: var(--mixtmt_echarts_shootDis_ExpetGoal_awayColor);
      }
    }
  }
  .playerItem {
    .playerOther_container {
      &:hover {
        cursor: pointer;
        & ~ .playerName {
          color: var(--mixtmt_whiteColor);
          text-decoration: underline;
          border-radius: 0.277vw;
        }
      }
    }
    .playerName {
      &:hover {
        cursor: pointer;
        color: var(--mixtmt_whiteColor);
        text-decoration: underline;
        border-radius: 0.277vw;
      }
    }
  }
  &.onlyDisplay {
    padding: 1.388vw 0 1.11vw 0;
    .lineup_playgroundArea {
      /* padding-top: 0; */
      .teamInfor_header {
        /* top: 0; */
      }
    }
    .homeTeam,
    .awayTeam {
      .playerItem {
        .playerOther_container {
          &:hover {
            cursor: default;
            & ~ .playerName {
              background-color: transparent;
              color: var(--mixtmt_greyColor3);
              text-decoration: none;
              border-radius: 0;
            }
          }
        }
        .playerName {
          &:hover {
            cursor: default;
            background-color: transparent;
            color: var(--mixtmt_greyColor3);
            text-decoration: none;
            border-radius: 0;
          }
        }
      }
    }
  }
}
</style>
